import { Injectable } from '@angular/core';
import { BehaviorSubject ,  Observable } from 'rxjs';

import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable()
export abstract class ListaCompartilhadaService<T extends BaseEntity> {
  private lista$ = new BehaviorSubject<T[]>([]);

  constructor() { }

  addLinha(linha: T) {
    const lista = [linha, ...this.lista$.getValue()];
    this.lista$.next(lista);
  }

  removeLinha(linha: T) {
    const lista = this.lista$.getValue().filter(e => e.id !== linha.id);
    this.lista$.next(lista);
  }

  atualizaLinha(linha: T) {
    const lista = this.lista$.getValue().map(e => {
      if (e.id === linha.id) {
        return linha;
      }
      return e;
    });
    this.lista$.next(lista);
  }

  setLista(lista: T[]) {
    this.lista$.next(lista);
  }

  getLista(): Observable<T[]> {
    return this.lista$.asObservable();
  }
}
